



















// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import CartItem from '@/components/panier/CartItem.vue'
import { AloPanier } from '@/models/alo/AloPanier'

@Component({
  name: 'CartDetail',
  props:{
    panier:{
      type:Object,
      required:true
    },
    readOnly:{
      type:Boolean,
      default:false
    }    
  },
  components:{
    CartItem
  }
})
export default class CartDetail extends Vue {
  
  private panier!:AloPanier  
  private readOnly!:Boolean
 
  get nbItems(){
    return this.panier.nbItems
  }

  udpateQty(fftId:number,qty:number){        
    this.$emit("udpateQty",{fftId,qty})          
  }  

}
